import React, { useEffect, useRef, useState } from 'react';

import { Block, withConfig } from '../common/Block.jsx';

function _Code(props) {
    if (!props.blockConfig || !props.blockConfig.block) {
        return null;
    }
    let style;
    if (props.builder) {
        style = { minHeight: '18px', minWidth: '18px' };
    } else if (!props.blockConfig.block.html || props.blockConfig.block.html.length == 0) {
        return null;
    }
    const [timeoutHandler, setTimeoutHandler] = useState(undefined);
    const refContent = useRef(undefined);
    useEffect(() => {
        if (!props.builder) {
            return;
        }
        if (timeoutHandler) {
            clearTimeout(timeoutHandler);
            setTimeoutHandler(undefined);
        }
        const temp = setTimeout(function () {
            if (!refContent || !refContent.current) {
                setTimeoutHandler(undefined);
                return;
            }
            refContent.current.innerHTML = refContent.current.innerText;
            setTimeoutHandler(undefined);
        }, 100);
        setTimeoutHandler(temp);
    }, [props.blockConfig.block.html]);

    if (props.blockConfig && props.blockConfig.layout) {
        if (!style) {
            style = {};
        }
        Block.mapStyleConfigProps(style, props.blockConfig.layout);
    }
    if (props.builder && props.blockConfig.block.html && props.blockConfig.block.html.indexOf('<script') >= 0) {
        return (
            <div className="builder-block-unavailable" style={style}>
                <div className="notice">This block contains embedded scripts and may not render correctly in the builder.<br />Save and preview your site to verify the script behavior.</div>
                <div ref={refContent} className="content" dangerouslySetInnerHTML={{ __html: props.blockConfig.block.html }} style={{ opacity: timeoutHandler == undefined ? 1 : 0 }} />
            </div>
        );
    }
    return <div className="code" dangerouslySetInnerHTML={{ __html: props.blockConfig.block.html }} style={style} />;
}
const Code = withConfig(_Code);

export default { Component: Code };